export default {"src":"/_next/static/media/graph.a77d0780.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};